import 'whatwg-fetch';


export const downloadSpeakers = () => (
  (dispatch) => {
    fetch('/api/speakers-and-branches-list1.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          const sections = json.speakerViewList.eventBranchViews.map(section => {
            const speakerViewList = json.speakerViewList.speakerViews.filter(element => {
              const ev = element.roomEventShortViews.filter(room => {
                if (room.eventBranchId === section.id) {
                  return room;
                }
                return null;
              })
              if (ev && ev.length !== 0) {
                return ev[0];
              }
              return null;
            });
            return {...section, speakerViewList: speakerViewList};
          });
          dispatch({
            type: 'PARSE_SPEAKERS_LIST',
            sections: sections
          })
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'SPEAKERS_ERROR',
          error: err,
        })
      })
  }
);

export const downloadSpeaker = (user) => (
  (dispatch) => {
    fetch(`/api/speaker-object/${user.id}.json`)
      .then(response => {
        return response.json()
      })
      .then(json => {
console.log(json);
        if (json.success) {
          dispatch({
            type: 'PARSE_SPEAKER_INFO',
            speakerView: json.speakerViewWithRoomEventTime
          })
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'SPEAKERS_ERROR',
          error: err,
        })
      })
  }
);



// WEBPACK FOOTER //
// ./src/speakers-page/actions.js